<script>
import apiEndpoints from "@/services/apiEndpoints";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import datetime from "@/mixins/datetime";

export default {
  mixins: [tableSearch, datetime],
  components: {
    CommonTableComponent
  },
  data() {
    return {
      isLoading: false,
      dataSelected: [],
      data: [],
      headers: [
        {
          text: '承認日時',
          name: 'scheduled_work_date',
          width: 20
        }, {
          text: '承認者',
          name: 'start_time',
          width: 15
        }, {
          text: '修正内容',
          name: 'work_end_date'
        },
      ],
      wasteOrServiceByDailyReportId: null,
      vendorSiteId: null,
    }
  },
  methods: {
    async getData() {
      if (!this.wasteOrServiceByDailyReportId) return;

      this.isLoading = true;
      const url = apiEndpoints.approval_histories_by_daily_report(this.wasteOrServiceByDailyReportId, this.vendorSiteId);
      const {status, data} = await this.$http.get(url);
      if (status) {
        this.data = data.result;
      }
      this.isLoading = false;
    },
    openModal(wasteOrServiceByDailyReportId, vendorSiteId) {
      this.wasteOrServiceByDailyReportId = wasteOrServiceByDailyReportId;
      this.vendorSiteId = vendorSiteId;
      this.$nextTick(() => {
        this.$bvModal.show("modal-approval-history");
      })
    },
    closeModal() {
      this.$bvModal.hide("modal-approval-history");
    },
  }
}
</script>
<template>
  <div class="d-xl-flex">
    <slot name="openBtn">

    </slot>
    <!-- modal area -->
    <b-modal
      title="修正履歴一覧"
      size="xl"
      id="modal-approval-history"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                  <span v-else>
                  {{ item.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-if="!vendorSiteId">
                <tr v-for="item in data">
                  <td>{{ item.transport_approved_at | longDate }} {{ item.transport_approved_at | time }}</td>
                  <td>{{ item.transport_approved_by_user.user_name }}</td>
                  <td>{{ item.transport_comment }}</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="item in data">
                  <td>{{ item.treatment_approved_at | longDate }} {{ item.treatment_approved_at | time }}</td>
                  <td>{{ item.treatment_approved_by_user.user_name }}</td>
                  <td>{{ item.treatment_comment }}</td>
                </tr>
              </template>
              <tr v-if="!data.length">
                <td colspan="3" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <button
              size="lg"
              class="btn btn-primary waves-effect waves-light"
              @click="closeModal"
            >
              <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
